/**
 * Accordion component - WordPress compatible
 * Uses jQuery for reliable animations
 */
(function($) {
  'use strict';

  if (typeof $ === 'undefined') {
    console.error('Accordion: jQuery is required');
    return;
  }

  function initAccordions() {
    var $accordions = $('.accordion');

    if ($accordions.length === 0) {
      return;
    }

    $accordions.each(function() {
      var $accordion = $(this);

      // Skip if already initialized
      if ($accordion.data('accordion-init')) {
        return;
      }
      $accordion.data('accordion-init', true);

      // Find all icon containers as the toggle triggers
      var $icons = $accordion.find('.accordion__icon-container');

      $icons.each(function() {
        var $icon = $(this);
        var $trigger = $icon.closest('.accordion__button');
        var $item = $trigger.closest('.accordion__item');
        var $content = $item.find('.accordion__content');

        // Skip if no content
        if ($content.length === 0) {
          $trigger.addClass('accordion__button--static');
          return;
        }

        // Set initial hidden state
        $content.css({
          height: 0,
          opacity: 0,
          overflow: 'hidden',
          display: 'none'
        });

        // Click handler - only on icon
        $icon.on('click.accordion', function(e) {
          e.preventDefault();
          e.stopPropagation();

          var isOpen = $trigger.hasClass('accordion__button--active');

          // Close all other items first (not the clicked one yet)
          $icons.not($icon).each(function() {
            var $otherTrigger = $(this).closest('.accordion__button');
            var $otherItem = $otherTrigger.closest('.accordion__item');
            var $otherContent = $otherItem.find('.accordion__content');

            if ($otherTrigger.hasClass('accordion__button--active')) {
              var $otherIcon = $otherItem.find('.accordion__icon-container');
              $otherTrigger.removeClass('accordion__button--active');
              $otherIcon.attr('aria-expanded', 'false');
              $otherItem.removeClass('accordion__item--active');
              $otherContent.removeClass('accordion__content--active').stop(true).animate({
                height: 0,
                opacity: 0
              }, 300, function() {
                $(this).css('display', 'none');
              });
            }
          });

          // Toggle the clicked item
          if (isOpen) {
            // Close it
            $trigger.removeClass('accordion__button--active');
            $icon.attr('aria-expanded', 'false');
            $item.removeClass('accordion__item--active');
            $content.removeClass('accordion__content--active').stop(true).animate({
              height: 0,
              opacity: 0
            }, 300, function() {
              $(this).css('display', 'none');
            });
          } else {
            // Open it - show element, then get natural height
            $content.css({ display: 'block', height: 'auto' });
            var naturalHeight = $content.outerHeight();
            $content.css('height', 0);

            // Apply active states
            $trigger.addClass('accordion__button--active');
            $icon.attr('aria-expanded', 'true');
            $item.addClass('accordion__item--active');
            $content.addClass('accordion__content--active').stop(true).animate({
              height: naturalHeight,
              opacity: 1
            }, 300, function() {
              // Set to auto after animation completes
              $(this).css('height', 'auto');
            });
          }
        });

        // No manual keyboard handler needed - <button> provides
        // Enter and Space key activation natively
      });
    });
  }

  // Initialize on document ready
  $(document).ready(function() {
    initAccordions();
  });

  // Also initialize on window load as fallback
  $(window).on('load', function() {
    initAccordions();
  });

  // Export for manual initialization if needed
  window.initAccordions = initAccordions;

})(window.jQuery);
